module.exports = __webpack_public_path__ + "img/relieve.755fba37.png";